import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {ListResponse} from './list-response';
import {CategoryModel} from './category-model';
import {MainCategoryModel} from './main-category-model';
import {ActivateCategoryRequestModel} from './activate-category-request-model';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {
  constructor(private httpClient: HttpClient) { }

  public get(organizationId: string): Observable<ListResponse<CategoryModel>> {
    return this.httpClient.get<ListResponse<CategoryModel>>(`/api/organizations/${organizationId}/categories`);
  }

  public getMain(): Observable<ListResponse<MainCategoryModel>> {
    return this.httpClient.get<ListResponse<MainCategoryModel>>(`/api/maincategories`);
  }

  public activate(organizationId: string, request: ActivateCategoryRequestModel): Observable<CategoryModel> {
    request.executorId = 'notemptystring';
    return this.httpClient.post<CategoryModel>(`/api/organizations/${organizationId}/categories/activate`, request);
  }

  public deactivate(organizationId: string, categoryId: string): Observable<object> {
    return this.httpClient.post(`/api/organizations/${organizationId}/categories/${categoryId}/deactivate`, null);
  }
}
